import { motion, useScroll, useTransform } from "framer-motion";
import Calculator from "./Calculator";

const LINES = ["SEE WHAT", "YOU'D ACTUALLY", "KEEP."];

export default function Hero() {
  const { scrollY } = useScroll();
  const yGhost = useTransform(scrollY, [0, 700], [0, 140]);

  return (
    <section data-testid="hero-section" className="relative min-h-[100svh] flex flex-col px-6 pt-6 pb-16 sm:px-10 lg:px-16">
      <header className="flex items-center justify-between" data-testid="site-header">
        <span className="font-display font-semibold tracking-tight text-lg" data-testid="brand-mark">
          AGENCY&nbsp;HQ<span className="text-[#FF3B30]">.</span>
        </span>
        <span className="text-[11px] uppercase tracking-[0.25em] text-[#555]">For real estate agents</span>
      </header>

      <motion.div
        aria-hidden
        style={{ y: yGhost }}
        className="pointer-events-none select-none absolute -right-6 top-24 font-display font-semibold text-[38vw] lg:text-[26vw] leading-none text-outline z-0"
      >
        95%
      </motion.div>

      <div className="relative z-10 flex-1 grid lg:grid-cols-12 gap-10 lg:gap-6 items-center mt-10 lg:mt-0">
        <div className="lg:col-span-7">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.1, duration: 0.6 }}
            className="text-[11px] sm:text-xs uppercase tracking-[0.3em] text-[#555] mb-6"
            data-testid="hero-overline"
          >
            Commission calculator — as promised in the ad
          </motion.p>

          <h1 className="font-display font-semibold tracking-tight leading-[0.95] text-5xl sm:text-6xl lg:text-7xl xl:text-8xl" data-testid="hero-headline">
            {LINES.map((line, i) => (
              <span key={line} className="block overflow-hidden pb-1">
                <motion.span
                  className={`block ${i === 2 ? "text-[#FF3B30]" : ""}`}
                  initial={{ y: "110%" }}
                  animate={{ y: 0 }}
                  transition={{ duration: 0.9, delay: 0.25 + i * 0.14, ease: [0.16, 1, 0.3, 1] }}
                >
                  {line}
                </motion.span>
              </span>
            ))}
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.6 }}
            className="mt-6 max-w-md text-base sm:text-lg text-[#555] leading-relaxed"
            data-testid="hero-subcopy"
          >
            Keep 85–95% of every commission. One flat $250/month. No lock-in contract, no startup fees — and a full back-end team behind you.
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.55, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5"
        >
          <Calculator />
        </motion.div>
      </div>
    </section>
  );
}
